import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import { Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'


const HD = [
    {
        "Name": "Dr. Rudra Sekhar Manna",
        "NameLink": "https://physics.iittp.ac.in/DrRudra.html",
        "Position": "Associate Professor",
        "Category": "Head of the Department",
        "Degree": "Ph.D, Goethe University Frankfurt, Germany (2012)",
        "AreasofInterest": "Experimental Condensed Matter Physics.",
        "Phone": "0877 250 3450 / 3458",
        "Email": "hod_ph@iittp.ac.in / rudra.manna@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Rudra.jpg"
    }

   
]
const Faculty = [

    {
        "Name": "Dr. Aravinda S",
        "NameLink": "https://physics.iittp.ac.in/DrAravinda.html",
        "Position": "Associate Professor",
        "Degree": "Ph.D, Manipal University (Manipal Academy of Higher Education).",
        "AreasofInterest": "Quantum information and computation, Quantum Foundations.",
        "Phone": "0877 250 3462",
        "Email": "aravinda@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Arv.JPG"
    },

    {
        "Name": "Dr. Arijit Sharma",
        "NameLink": "https://physics.iittp.ac.in/DrArijit.html",
        "Position": "Associate Professor",
        "Degree": "Ph.D, Raman Research Institute, Bengaluru, India",
        "AreasofInterest": "Experimental Atomic Physics and Quantum Optics, Precision Laser Spectroscopy.",
        "Phone": "0877 250 3455",
        "Email": "arijit@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Arijit.jpg"
    },
    {
        "Name": "Dr. Koteswara Rao Bommisetti",
        "NameLink": "https://physics.iittp.ac.in/DrKoteswara.html",
        "Position": "Associate Professor",
        "Degree": "Ph.D, Indian Institute of Technology Bombay, India",
        "AreasofInterest": "Strongly Correlated Electron Systems, Geometrically Frustrated Magnets.",
        "Phone": "0877 250 3456",
        "Email": "koteswararao@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/koteshwararao.jpg"
    },
   
    {
        "Name": "Dr. Reetesh Kumar Gangwar",
        "NameLink": "https://physics.iittp.ac.in/DrReetesh.html",
        "Position": "Associate Professor",
        "Degree": "Ph.D, Depatment of Physics, IIT Roorkee, INDIA",
        "AreasofInterest": "Atomic and Molecular Physics, Plasma Physics ",
        "Phone": "0877 250 3457",
        "Email": " reetesh@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/reetesh.jpg"
    },
     {
        "Name": "Dr. Ranjan Krishna Modak",
        "NameLink": "https://physics.iittp.ac.in/DrRanjan.html",
        "Position": "Associate Professor",
        "Degree": "Ph.D, Indian Institute of Science (IISc), Bangalore, India.",
        "AreasofInterest": "Theoretical Condensed Matter Physics",
        "Phone": "0877 250 3463",
        "Email": "ranjan@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/modak.jpg"
    },
    {
        "Name": "Dr. Vinay Pramod Majety",
        "NameLink": "https://physics.iittp.ac.in/DrVinay.html",
        "Position": "Associate Professor",
        "Degree": "Ph.D, Ludwig Maximilians University, Germany",
        "AreasofInterest": "Theoretical ultrafast few body physics",
        "Phone": "0877 250 3460",
        "Email": "vinay.majety@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/vinay.jpg"
    },


    {
        "Name": "Dr. Aniket Joglekar",
        "NameLink": "https://physics.iittp.ac.in/DrAniket.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, University of Chicago.",
        "AreasofInterest": "Astroparticle Physics, Beyond the SM Physics.",
        "Phone": " ",
        "Email": "aniket@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/aniket.png"
    },
    
     {
        "Name": "Dr. Avinash Patsha",
        "NameLink": "https://physics.iittp.ac.in/DrAvinash.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, Homi Bhabha National Institute (HBNI), Mumbai, India.",
        "AreasofInterest": "2D Quantum Materials and Devices, Semiconductor Nanostructures and Quantum optoelectronics",
        "Phone": " ",
        "Email": "avinash@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Avinash_Patsha.png"
    },
     {
        "Name": "Dr. Dr. Lakshmi Ganapathi Kolla",
        "NameLink": "https://physics.iittp.ac.in/Dr.Kolla.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, Indian Institute of Science, Bangalore, India",
        "AreasofInterest": "Experimental Physics: Nanoscale Quantum Devices, Functional Materials for Electronics and Quantum Technologies",
        "Phone": " ",
        "Email": "klganapathi@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Kolla_Ganapathi.png"
    },
    
    {
        "Name": "Dr. Kapildeb Dolui",
        "NameLink": "https://physics.iittp.ac.in/DrKapil.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, Trinity College Dublin, Ireland.",
        "AreasofInterest": "Computational Condensed Matter Physics, Materials Science",
        "Phone": " ",
        "Email": "doluik@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Kapildeb_Dolui.png"
    },
    {
        "Name": "Dr. Khaire Vikram Kisan",
        "NameLink": "https://physics.iittp.ac.in/DrVikram.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, Inter-University Centre for Astronomy and Astrophysics (IUCAA), Pune.",
        "AreasofInterest": "Astronomy and Astrophysics, Machine Learning",
        "Phone": "0877 250 3464",
        "Email": "vikramk@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Khaire_Vikram_Kisan_AP.png"
    },
    // {
    //     "Name": "Dr. Kaushalya Jhuria",
    //     "NameLink": "https://physics.iittp.ac.in/DrKaushalya.html",
    //     "Position": "Assistant Professor",
    //     "Degree": "Ph.D, CNRS Lab (IJL), France.",
    //     "AreasofInterest": "Quantum information science, THz Spintronics",
    //     "Phone": " ",
    //     "Email": "kaushalya@iittp.ac.in",
    //     "Image": "https://files.iittp.ac.in/images/demo/iit/Dr_Kaushalya_Jhuria_AP.png"
    // },
    {
        "Name": "Dr. Murari Singh",
        "NameLink": "https://physics.iittp.ac.in/DrMurari.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, School of Physical Sciences, Jawaharlal Nehru University, New Delhi, India.",
        "AreasofInterest": "Computational Soft Matter Physics",
        "Phone": "0877 250 3461",
        "Email": "murari.singh@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/murari_s.jpg"
    },
   
   
    {
        "Name": "Dr. Shaon Sahoo",
        "NameLink": "https://physics.iittp.ac.in/DrShaon.html",
        "Position": "Assistant Professor",
        "Degree": "Ph.D, IISc, Bangalore, India",
        "AreasofInterest": "Theoretical Condensed Matter Physics",
        "Phone": "0877 250 3459",
        "Email": "shaon@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/photo_shaon.jpg"
    }
   
]

const AdjunctFaculty = [


    {
        "Name": "Prof. V Vasudeva Rao",
        "NameLink": "https://physics.iittp.ac.in/DrVVRao.html",
        "Position": "Adjunct Professor",
        "Degree": "Ph.D, IIT Madras, India",
        "AreasofInterest": "Superconductivity & Applications, Quantum Computing, Vacuum Technology, Cryogenic Engineering, Semiconductor Engineering.",
        "Email": "vvr@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof_Vasudeva_Rao_VF.png"
    }

]

const GuestFaculty = [


    {
        "Name": "Dr. P.C.Deshmukh",
        // "NameLink": "/dr-p-c-deshmukh",
        "Position": "Professor",
        // "Degree": "Ph.D, Nagpur University, India",
        // "AreasofInterest": "Photoabsorption Processes in Free/Confined atoms, molecules, and ions.",
        // "Phone": "0877 250 3033",
        // "Email": "pcd@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/PCD.jpg"
    },
    {
        "Name": "Dr. T. S. Natarajan",
        // "NameLink": "/dr-t-s-natarajan",
        "Position": "Professor",
        // "Degree": "Ph.D, IIT Madras, India",
        // "AreasofInterest": "Conducting Polymer, Polymer nanofibers",
        // "Phone": "0877 250 3031",
        // "Email": "tsniit@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/demo/iit/Prof.-tsn.jpg"
    }




]


function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="PHYSICS" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> People
                                </h5>
                                <h3>PHYSICS</h3>
                            </div>
                        </div>
                    </div>

                    <Row>
                        <Col md={3} className='c-left custom-padding-color mb-4'>
                            <DeptLeft activeIndex={9} />
                        </Col>
                        <Col md={9} className='c-right'>
                            {/*--------------------------- Head of the dept */}

                            <div className="row justify-content-center">
                                <h3 className='c-headline mt-5 mb-5'>Head of the Department</h3>
                                {HD.map((Faculty, index) => (
                                    <div key={index} className="col-xl-5 col-md-6">
                                        {/* 
                                {index === 0 || Faculty.Category !== HD[index - 1].Category ? (
                                    <div>
                                        <h5 className="font-weight-bold text-teal">{Faculty.Category}</h5>
                                        <hr/> <br/>
                                    </div>
                                ) : null} */}

                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to="#">
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                      <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span>{Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            {/*--------------------------- Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Faculty</h3>
                                {Faculty.map((Faculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={Faculty.NameLink}>
                                                        <img src={Faculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={Faculty.NameLink}>{Faculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{Faculty.Position}</p>
                                                    <p className="text-dark">{Faculty.Degree}</p>
                                                      <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span>{Faculty.AreasofInterest}</p>

                                                    {(Faculty.Phone !== undefined && Faculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{Faculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {Faculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                          

                            {/*--------------------------- Visiting Faculty*/}
                            {/* <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Visiting Faculty</h3>
                                {VisitingFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                      <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span>{GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> */}

                             {/*--------------------------- Adjunct Faculty*/}
                            <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Adjunct Faculty</h3>
                                {AdjunctFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                      <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span>{GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                              {/*--------------------------- Guest Faculty*/}
                              <div className="row">
                                <h3 className='c-headline mt-5 mb-5'>Former Faculty</h3>
                                {GuestFaculty.map((GuestFaculty, index) => (
                                    <div key={index} className="col-xl-4 col-md-6">
                                        <div className={`single-team mb-40 ${index == 0 ? "c-highlight" : ""}`}>
                                            <div className="team-thumb">
                                                <div className="brd">
                                                    <Link to={GuestFaculty.NameLink}>
                                                        <img src={GuestFaculty.Image} alt="img" />
                                                    </Link>
                                                </div>
                                            </div>
                                            <div className="team-info">
                                                <h4>
                                                    <Link to={GuestFaculty.NameLink}>{GuestFaculty.Name}</Link>
                                                </h4>

                                                <div className="text-dark c-lineheight2">
                                                    <p > <i className="fal fa-graduation-cap me-2" />{GuestFaculty.Position}</p>
                                                    <p className="text-dark">{GuestFaculty.Degree}</p>
                                                      {/* <p className="text-dark"> <span className='fw-bold text-dark'> Areas of Interest: </span>{GuestFaculty.AreasofInterest}</p>

                                                    {(GuestFaculty.Phone !== undefined && GuestFaculty.Phone !== "") && (
                                                        <p className="text-dark"><i className="fal fa-phone-alt me-2"></i>{GuestFaculty.Phone}</p>
                                                    )}
                                                    <p className="text-dark"><i className="fal fa-envelope  me-1"></i>  {GuestFaculty.Email}</p> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </Col>
                    </Row>
                </div>
            </section>
        </>
    )
}

export default Main